import React from 'react';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import TextField from '@material-ui/core/TextField';
import axios from 'axios'
import {useTranslation} from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {updateHereToken} from "../../store/actionCreators";
import {connect} from "react-redux";


const SelectAddress = ({updateHereToken, className, hereToken, input: {value, onChange: setValue}}) => {
    const [inputValue, setInputValue] = React.useState(value?.title);
    const [isActive, setIsActive] = React.useState(!!value );
    const [options, setOptions] = React.useState([]);
    const {t} = useTranslation()

    const fetch = (query) =>{
                        axios.get(`https://geocode.search.hereapi.com/v1/discover?at=20.59209,-100.39601&in=countryCode:MEX&limit=5&lang=es-MX&apiKey=_NNcFTyMk_21EOVZcDV_ddLd0EU6aevdLH5XGXKSz0s&q=${query}`, {
                    headers: {
                        Authorization: hereToken
                    }
                }).then(({data: newOptions}) => {
                    setOptions(newOptions.items)
                }).catch((err) => {
                    if (err.message === 'Request failed with status code 401') {
                        updateHereToken()
                    }
                })
            }

    React.useEffect(() => {
        if (inputValue === '' || !hereToken) {
            return
        }
        fetch(inputValue)

    }, [inputValue,hereToken]);
    return (
        <div className={className}>
            <FormControlLabel
                control={<Checkbox color={'primary'} checked={isActive} onChange={(a) => {
                    setIsActive(prev => !prev)
                    if (isActive) {
                        setValue(null)
                    }
                }
                }/>}
                label={t('is_receive_clients')}
            />
            <Autocomplete
                getOptionLabel={(option) => option?.title || ""}
                options={options}
                autoComplete
                includeInputInList
                filterSelectedOptions
                filterOptions={(options) => options}
                disabled={!isActive}
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                renderInput={(params) => (
                    <TextField {...params} label="dirección" variant="outlined"/>
                )}
                noOptionsText={t('no-options')}
                renderOption={(option) => {
                    return (
                        <Grid container alignItems="center">
                            <Grid item>
                                <LocationOnIcon color={'primary'}/>
                            </Grid>
                            <Grid item xs>
                                {option.title}
                            </Grid>
                        </Grid>
                    );
                }}
            />
        </div>
    )
}


const mapStateToProps = (state) => ({
    hereToken: state.general.hereToken
})
const mapDispatchToProps = dispatch => ({
    updateHereToken: updateHereToken(dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(SelectAddress);